module.exports = __webpack_public_path__ + "1ecc129b2446d4ebea31b1998c8077ed.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/groen.mp3
// module id = 31
// module chunks = 0